import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.EmailConfirmationPage', {
    title: 'Email Confirmation',
    description: 'Please check your email and click the link to confirm your email address.',
});
